import { useEffect, useMemo } from 'react';
import { useTimer } from 'react-timer-hook';

export const Timer = ({
  hour,
  minute,
  second,
}: {
  hour: number;
  minute: number;
  second: number;
}) => {
  const time = new Date();
  time.setHours(time.getHours() + Number(hour));
  time.setMinutes(time.getMinutes() + Number(minute));
  time.setSeconds(time.getSeconds() + Number(second));
  const { seconds, minutes, hours } = useTimer({ expiryTimestamp: time });

  return (
    <>
      {hours < 10 ? `0${hours}` : hours}:
      {minutes < 10 ? `0${minutes}` : minutes}:
      {seconds < 10 ? `0${seconds}` : seconds}
    </>
  );
};

export const useGetTime = ({
  hour,
  minute,
  second,
}: {
  hour: string | number;
  minute: string | number;
  second: string | number;
}) => {
  const time = new Date();
  time.setHours(time.getHours() + Number(hour));
  time.setMinutes(time.getMinutes() + Number(minute));
  time.setSeconds(time.getSeconds() + Number(second));
  const { seconds, minutes, hours, restart } = useTimer({
    expiryTimestamp: time,
  });

  useEffect(() => {
    if (Number(hour) + Number(minute) + Number(second) > 0) {
      restart(time);
    }
  }, [hour, minute, second]);

  return `${hours < 10 ? `0${hours}` : hours}:${
    minutes < 10 ? `0${minutes}` : minutes
  }:${seconds < 10 ? `0${seconds}` : seconds}`;
};
